<template>
    <div class="container has-text-left padding_top_1rem">
        <b-field label="Name">
            <b-input v-model="name" placeholder="Device name" required></b-input>
        </b-field>
        <b-field label="Connected via">
            <b-select v-model="integrationId" placeholder="Choose...">
                <option :value="0">Choose...</option>
                <option
                        v-for="integrationType in integrations"
                        v-bind:key="integrationType.id"
                        :value="integrationType.id"
                >{{integrationType.name}}</option>
            </b-select>
        </b-field>
        <b-field label="Internal ID" v-show="visibleInternalId">
            <b-input v-model="internalId" placeholder="Set internal id"></b-input>
        </b-field>
        <b-field label="Parent Device" v-show="visibleParent">
            <b-select v-model="deviceParentId" placeholder="Choose...">
                <option :value="0">Choose...</option>
                <option
                        v-for="parentDevice in availableParents"
                        v-bind:key="parentDevice.id"
                        :value="parentDevice.id"
                >{{parentDevice.name}}</option>
            </b-select>
        </b-field>
        <b-field label="Device Type">
            <b-select v-model="deviceTypeId" placeholder="Choose...">
                <option :value="0">Choose...</option>
                <option
                        v-for="deviceType in deviceTypes"
                        v-bind:key="deviceType.id"
                        :value="deviceType.id"
                >{{deviceType.name}}</option>
            </b-select>
        </b-field>
        <b-field label="Manufacturer">
            <b-select v-model="manufacturerId" placeholder="Choose...">
                <option :value="0">Choose...</option>
                <option
                        v-for="manufacturer in manufacturers"
                        v-bind:key="manufacturer.id"
                        :value="manufacturer.id"
                >{{manufacturer.name}}</option>
            </b-select>
        </b-field>
        <b-field label="Room">
            <b-select v-model="roomId" placeholder="Choose...">
                <option :value="0">Choose...</option>
                <option
                        v-for="room in rooms"
                        v-bind:key="room.id"
                        :value="room.id"
                >{{room.name}}</option>
            </b-select>
        </b-field>
        <b-field label="Plugged">
            <b-select v-model="plugged" placeholder="Choose...">
                <option :value="0">On Battery</option>
                <option :value="1">Yes</option>
            </b-select>
        </b-field>
        <b-button type="is-success" :disabled="!validFields()" @click="handleAdd">Add</b-button>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BSelect from "buefy/src/components/select/Select";
  import BButton from "buefy/src/components/button/Button";

  export default {
    components: {
      BButton,
      BSelect,
      BInput,
      BField},
    name: "add-device",
    props: ['afterAdd'],
    data() {
      return {
        name: '',
        integrationId: 0,
        networkTypeId: 0,
        deviceTypeId: 0,
        deviceParentId: 0,
        manufacturerId: 0,
        internalId: 0,
        plugged: 1,
        roomId: 0
      };
    },
    computed: {
      ...mapGetters('devices', ['devices', 'networkTypes', 'deviceTypes', 'manufacturers']),
      ...mapGetters('rooms', ['rooms']),
      ...mapGetters('integrations', ['integrations']),
      visibleInternalId() {
        return true;
      },
      visibleParent() {
        return parseInt(this.integrationId) === 1;
      },
      availableParents() {
        if (!this.devices) {
          return [];
        }

        return this.devices.filter(item => {
          return (parseInt(item.parent_id) === 0 && parseInt(item.network_type_id) === 1);
        });
      }
    },
    methods: {
      ...mapActions('devices', ['createDevice']),
      validFields() {
        if (this.name.length < 1) {
          return false;
        }

        if (this.integrationId === 0) {
          return false;
        }

        if (this.deviceTypeId === 0) {
          return false;
        }

        if (this.manufacturerId === 0) {
          return false;
        }

        return true;
      },
      handleAdd() {
        this.createDevice({
          name: this.name,
          integrationId: this.integrationId,
          deviceTypeId: this.deviceTypeId,
          deviceParentId: this.deviceParentId,
          manufacturerId: this.manufacturerId,
          internalId: this.internalId,
          roomId: this.roomId,
          plugged: this.plugged
        });
        this.afterAdd();
      }
    }
  }
</script>

<style scoped>
    .padding_top_1rem {
        padding-top: 1rem;
    }
</style>